import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import Square from '../Square';

const StackList = props => {
  const occurrences = isNil(props.conditionIndex)
    ? []
    : props.conditions[props.conditionIndex].occurrences[props.occurrenceRow][
        props.occurrenceIndex
      ].map((e, i) => {
        return (
          <Square
            key={i}
            editable={false}
            draggable
            dragHandler={e => {
              e.dataTransfer.effectAllowed = 'move';

              /**
               * Serves only one purpose, make firefox happy. Does not drag otherwise.
               */
              e.dataTransfer.setData('firefox', false);
            }}
            dragEndHandler={e => {
              props.dragOccurrenceHandler &&
                props.dragOccurrenceHandler(
                  e,
                  props.conditionIndex,
                  props.occurrenceRow,
                  props.occurrenceIndex,
                  i
                );
            }}
            occurrence={e}
          />
        );
      });

  return (
    <PhotoBoothModal
      {...props}
      dragOverHandler={e => {
        e.preventDefault();
      }}
    >
      <div className="occurrence-stack">{occurrences}</div>
    </PhotoBoothModal>
  );
};

StackList.propTypes = {
  ...PhotoBoothModal.propTypes,
  dragOccurrenceHandler: PropTypes.func,
  conditions: PropTypes.array,
  conditionIndex: PropTypes.number,
  occurrenceRow: PropTypes.number,
  occurrenceIndex: PropTypes.number
};

StackList.defaultProps = {
  ...PhotoBoothModal.defaultProps,
  conditions: [],
  conditionIndex: null,
  occurrenceRow: null,
  occurrenceIndex: null
};

export default StackList;



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/StackList.js